import React, {useEffect} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function ConfirmDialog(props) {

  const [open, setOpen] = React.useState(false)

  const handleAccept = () =>{
    props.onAccept()
    handleClose()
  }

  const handleCancel = () =>{
    props.onCancel()
    handleClose()
  }

  const handleClose = () =>{
    setOpen(false)
    props.onClose()    
  }

  useEffect(() => {
    setOpen(props.confirm_dialog)
  });

  var errors = []

  if (props.errors.errors){
    if (props.errors.errors.status_code !== 404){
      var keys = Object.keys(props.errors.errors); 
      for(var i = 0; i < keys.length; i++) {   
        var key = (keys[i]) ; 
        var key_errors = props.errors.errors[key]
        key_errors.map((val,idx)=>{
          errors.push(val)
        })
      }
    } else {
      errors.push(props.errors.errors.message)
    }
  }
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.message}
            {errors.map((val,idx)=>{

              return (
                <div>{val}</div>
              )
            })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary" variant="contained">
            Cancelar
          </Button>
          <Button onClick={handleAccept} color="primary" autoFocus variant="contained">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
